module.exports = __webpack_public_path__ + "img/kunxiang.png";